

exports.__esModule = true;
exports.$InventoryModel = undefined;

var _squid = require('squid');

var $InventoryModel = exports.$InventoryModel = _squid.$Model.extend('$InventoryModel', {
    api: new _squid.$Api({
        uri: '/api/catalog/:id/item/',
        postAttempts: 2,
        cache: true
    }),

    setInvetoryItems: function setInvetoryItems(inventoryItems) {
        this.inventoryItems = inventoryItems;
    },

    getInventoryItems: function getInventoryItems() {
        return this.inventoryItems;
    }
});

angular.value("$InventoryModel", $InventoryModel);
_squid.$Model;

_squid.$Api;


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-models/src/inventory/index.js
// module id = ../node_modules/xo-models/src/inventory/index.js
// module chunks = 0